import { useGitStatus } from '@common/ExternalGitStatus/useExternalGitStatus';
import { captureException } from '@common/sentry';
import { API_FAILURE } from '@common/sentry/groups';
import { SentryTags, GqlErrorTags } from '@common/sentry/SentryTags';
import { Text } from '@prophecy/ui-v3';
import { Dialog } from '@prophecy/ui-v3/Dialog';
import { MessageDetail } from '@prophecy/ui-v3/LegacyToast';

import { ReactQueryError, toGraphQlError } from '../../data/util';
import { useCheckGitTokenValidity } from './GitCheckTokenValidity';

export function useGitQueryDefaultErrorHandler(projectId: string) {
  const { checkGitTokenValidity } = useCheckGitTokenValidity();
  const { isExternal } = useGitStatus(projectId);
  return isExternal
    ? <S extends ReactQueryError>(errorResponse: S, queryName?: string) => {
        const { message: errorMessage, error } = toGraphQlError(errorResponse);
        captureException({
          exception: error,
          errorTags: { [SentryTags.ProphecyErrorGqlType]: queryName || GqlErrorTags.QueryError },
          groupAs: API_FAILURE
        });
        Dialog.alert({
          'data-test-id': 'git-token-validation-error-dialog',
          title: <Text level='sm'>Error</Text>,
          children: <MessageDetail content={errorMessage} />,
          size: 'l',
          iconPlacement: 'right',
          closeButton: { children: 'Close' },
          onOk: () => checkGitTokenValidity(projectId),
          okButton: { children: 'Validate Git Token' }
        });
      }
    : undefined;
}
